//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 export default {
  name: 'newsItem',
  props: ['resource', 'index', 'minimal', 'ratio', 'type', 'thumb'],
  components: {
    dateviews: () => import('~/components/date_views')
  }
}
